import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccountService } from '../../../../../services/account.service';

@Component({
  selector: 'app-removeadword-dialog',
  templateUrl: './removeadword-dialog.component.html',
  styleUrls: ['./removeadword-dialog.component.css']
})
export class RemoveadwordDialogComponent implements OnInit {

  api_error: any;
  api_success: string;
  disableConfirmbtn = false;
  constructor(
    private dialogRef: MatDialogRef<any>,
     @Inject(MAT_DIALOG_DATA) public data: number,
     private accountService: AccountService) { }

  ngOnInit() {
  }
  public closeDialog() {
    this.dialogRef.close();
  }
  onDeleteConfirm() {
    this.api_error = '';
    this.api_success = '';
    this.disableConfirmbtn = true;
    this.accountService.deleteAdword(this.data['adwordId'], this.data['accountId'])
    .subscribe(
      data => {
        this.api_success = 'Adword removed Successfully';
        setTimeout(() => {
          this.dialogRef.close('reloadlist');
          }, 2000);
        },
     (error) => {
      this.api_error = error.error;
      this.disableConfirmbtn = false;
      }
    );
  }

}
